import { useCallback, useState } from 'react';

const useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === 'undefined') {
      return initialValue;
    }

    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (_error) {
      return initialValue;
    }
  });

  const setValue = useCallback((value) => {
    setStoredValue((previous) => {
      const valueToStore = value instanceof Function ? value(previous) : value;
      try {
        if (typeof window !== 'undefined') {
          window.localStorage.setItem(key, JSON.stringify(valueToStore));
        }
      } catch (_error) {
        // ignora
      }
      return valueToStore;
    });
  }, [key]);

  return [storedValue, setValue];
};

export default useLocalStorage;
